import { cronos as viemCronos } from 'viem/chains'

import type { AppChain } from './chain.types'

export const cronos = {
  ...viemCronos,
  custom: {
    name: 'Cronos',
    shortName: 'Cronos',
    morphoChainSlug: 'cronos',
    blockExplorer: { baseUrl: 'https://explorer.cronos.org', name: 'Cronos Explorer' },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x1Db002C086439d55B9f33E6c0693Eb850F7c0607',
          startBlock: 38459435n
        },
        MorphoBlue: {
          address: '0xDF9a1DC07e5dEe5ccCCaBeC35e446C70fAF7434e',
          startBlock: 38459435n
        },
        MetaMorphoV11Factory: {
          address: '0xEA67e5566Ca2c0176d9db172A7f9A1e1F22E9D3A',
          startBlock: 38459727n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0x05519a0835a1bFD90f110aA7ca46e9A5F81Ed3b4',
          startBlock: 38461643n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0xE39f6B5Dd03F4ce8C201b946E662E653d94fA121',
          startBlock: 44236918n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0x8840F99Bb2D4f69fb02b2d019384C5c98a11746c',
          startBlock: 38461643n
        },
        RegistryList: {
          address: '0x295e0aB80f8234398cd0E51C85D873ee69E5F0DD',
          startBlock: 38461812n
        }
      }
    }
  }
} as const satisfies AppChain<{ v1: true; v2: true }>
